<template>
    <div class="section-header">
        <h2 class="section-header__title" v-text="title" />
        <p v-if="subTitle" class="section-header__text" v-text="subTitle" />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        subTitle: {
            type: String,
            required: false
        }
    }
}
</script>
